module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/bookcase/bookcase.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/bookcase/bookcase.png
// module id = 524
// module chunks = 0